// extracted by mini-css-extract-plugin
module.exports = {"select-non-active-wrapper":"NonActiveButton_select-non-active-wrapper__3w9bG"};